<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

// Print a message to confirm the script is loaded
console.log("custom.js is successfully loaded and running.");

// Your existing code to add the class
document.addEventListener("DOMContentLoaded", function() {
  // Define the list of page handles to check for in the body class
  const pageHandles = ["about-us", "contact", "faqs", "returns", "sizing", "shipping", "warranty"]; // Update this list as needed

  // Check if the body has a class that matches any handle in the list
  const isTargetPage = pageHandles.some(handle => document.body.classList.contains(`page-${handle}`));
  // const isTargetPage = pageHandles.some(handle => document.body.classList.contains(`template-page`));

  if (isTargetPage) {
      // Select the first target element and add 'header-plain--transparent'
      const targetElement = document.querySelector(".header-navigation-wrapper .header-navigation.header-nav-plain");
      if (targetElement) {
          targetElement.classList.add("header-plain--transparent");
          console.log("Class 'header-plain--transparent' added to the header.");
      } else {
          console.log("Target element '.header-navigation-wrapper .header-navigation.header-nav-plain' not found.");
      }

      // Select the second target element and add multiple classes
      const mobileWrapper = document.querySelector(".section-header-mobile .header-mobile");
      if (mobileWrapper) {
          mobileWrapper.classList.add("p-absolute", "left-0", "right-0", "w-100", "zi-3", "header-mobile--transparent");
          console.log("Classes 'p-absolute', 'left-0', 'right-0', 'w-100', 'zi-3', 'header-mobile--transparent' added to '.header-mobile__wrapper.header-mobile--wrapper'.");
      } else {
          console.log("Target element '.header-mobile__wrapper.header-mobile--wrapper' not found.");
      }
  } else {
      console.log("Page handle does not match. No classes added.");
  }
});

document.addEventListener("DOMContentLoaded", function () {
  // Only execute if the body has the class `template-product`
  if (!document.body.classList.contains("template-product")) return;

  // Select all .productView-moreItem elements within .productView .productView-product
  const moreItems = document.querySelectorAll(".productView .productView-product .productView-moreItem");

  for (const moreItem of moreItems) {
    // Check if the .productView-moreItem is empty or contains only whitespace
    if (moreItem.textContent.trim() === "") {
      // Set the bottom padding directly to zero
      moreItem.style.paddingBottom = '0';
      continue; // Move to the next moreItem
    }

    // Select all .productView-info-value elements within .productView-info-item inside the current .productView-moreItem
    const infoValues = moreItem.querySelectorAll('.productView-info .productView-info-item .productView-info-value');

    // If there are no .productView-info-value elements, do not modify the padding
    if (infoValues.length === 0) {
      continue; // Move to the next moreItem
    }

    // Assume all .productView-info-value elements are empty
    let allEmpty = true;

    // Check each .productView-info-value element
    for (const infoValue of infoValues) {
      if (infoValue.textContent.trim() !== "") {
        // Found a non-empty value
        allEmpty = false;
        break;
      }
    }

    // If all .productView-info-value elements are empty, set bottom padding to zero
    if (allEmpty) {
      moreItem.style.paddingBottom = '0';
    }
  }
});